import React from "react";

import { Text } from "@performyard/py-components";

import Breadcrumbs from "../../../../components/Breadcrumbs";

interface WorkspaceDetailsBreadcrumbsProps {
	workspaceName: string;
	workspaceId: string;
	isAdmin?: boolean;
	previousSearchParams?: string;
}

const WorkspaceDetailsBreadcrumbs = ({
	workspaceName,
	workspaceId,
	isAdmin = false,
	previousSearchParams = "",
}: WorkspaceDetailsBreadcrumbsProps) => {
	if (isAdmin) {
		// Admin breadcrumbs: Meetings > [Workspace Name]
		return (
			<Breadcrumbs
				forceHardReload={true}
				pages={[
					{
						pageID: "meetings",
						label: "Meetings",
						url: "/company/meetings",
					},
					{
						pageID: "adminWorkspaceDetails",
						label: (
							<div className="py-line-clamp-1" style={{ maxWidth: "146px" }}>
								<Text size="paragraph-2" weight="regular">
									{workspaceName}
								</Text>
							</div>
						),
						url: `/meeting-workspaces/${workspaceId}`,
					},
				]}
			/>
		);
	}

	// Regular user breadcrumbs: Meeting Workspaces > [Workspace Name]
	return (
		<Breadcrumbs
			pages={[
				{
					pageID: "meetingWorkspaces",
					label: "Meeting Workspaces",
					url: previousSearchParams ? `/meeting-workspaces${previousSearchParams}` : "/meeting-workspaces",
				},
				{
					pageID: "workspaceDetails",
					label: (
						<div className="py-line-clamp-1" style={{ maxWidth: "146px" }}>
							<Text size="paragraph-2" weight="regular">
								{workspaceName}
							</Text>
						</div>
					),
					url: `/meeting-workspaces/${workspaceId}`,
				},
			]}
		/>
	);
};

export default WorkspaceDetailsBreadcrumbs;
